import { useBrand } from '@contexts/index'

import { CheckboxInput } from '../baseInputs'

const CustomerConsent = () => {
  const brand = useBrand()

  const privacyLink = 'https://www.toyota.co.uk/footer/privacy-policy'

  return (
    <div className="mt-8">
      <h5 className={`${brand === 'lexus' ? 'text-lg' : 'font-medium '} mb-4`}>
        <strong>
          CHECK: have you read/sent the data compliancy message to the customer?
        </strong>
      </h5>
      <p className="mb-8">
        Just to let you know, we will pass on your details onto your local
        Centre to get that booked in for you. For more details, you can find our
        privacy notice{' '}
        <a
          className="underline"
          href={privacyLink}
          target={'_blank'}
          rel={'noopener noreferrer'}
          data-gt-name="ctaevent"
          data-gt-action="consent-click-link"
          data-gt-label={privacyLink}
        >
          here.
        </a>
      </p>
      <CheckboxInput name={'customer_cans_consent'} value="yes">
        The customer is aware that their data is being transferred to the Centre
      </CheckboxInput>
    </div>
  )
}

export default CustomerConsent
